export default "__VITE_ASSET__BR37dXwu__"